module.exports = __webpack_public_path__ + "static/media/Coldiac-Regular.8086d327.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Coldiac-Regular.woff
// module id = 2920
// module chunks = 51